import debounce from 'lodash.debounce'
import React, { useCallback, useEffect, useRef, useState, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import reset from '../../assets/reset.png'
import review from '../../assets/review.svg'
import reviewed from '../../assets/star_filled.svg'
import Button from '../../components/Button/Button'
import {
    FETCH_QUESTION_SET,
    UPDATE_ACTIVE_SECTION,
    TOGGLE_STATE,
} from '../../constants/actionTypes'
import Api from '../../data'
import Answer from '../Answer/Answer'
import AnswerStatus from '../AnswerStatus/AnswerStatus'
import './QuestionSection.css'
import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import Mathjax from 'components/Mathjax'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

const mapStateToProps = (state) => ({
    queryparam: state.queryparam,
    instructions: state.instructions,
    mock_test_submit: state.mock_test_submit,
    testStatus: state.testStatus,
    testData: state.testpanel,
    deviceId: state.deviceId,
    toggle: state.toggleStatus,
})
const mapDispatchToProps = (dispatch) => ({
    onQuestionLoad: (payload) => {
        return new Promise((resolve, reject) => {
            dispatch({ type: FETCH_QUESTION_SET, payload })
            resolve()
        })
    },
    setToggle: (payload) => {
        dispatch({ type: TOGGLE_STATE, payload })
    },
    setActiveSection: (payload) =>
        dispatch({ type: UPDATE_ACTIVE_SECTION, payload }),
})

const QuestionSection = (props) => {
    const { t, i18n } = useTranslation()
    const [activeIndex, setActiveIndex] = useState(0)
    const [time, setTime] = useState(Date.now())
    const [ques, updateQues] = useState('')
    const wrapperRef = useRef(null)
    let fa = [
        { className: 'answered', name: 'Answered', value: '0' },
        { className: 'not-answered ', name: 'Not Answered', value: '3' },
        { className: 'marked-for-review', name: 'Marked for Review', value: '3' },
        { className: 'not-visited', name: 'Not Visited', value: '3' },
        {
            className: 'answered-for-review',
            name: 'Answered and Marked for Review',
            value: '3',
        },
    ]
    let s = 0
    let v = 0
    let r = 0
    let ra = 0
    let na = 0
    for (let i = 0; i < props.data.questionList.length; i++) {
        if (
            props.data.questionList[i].question.isAnswered &&
            !props.data.questionList[i].question.isMarkedForReview
        ) {
            s = s + 1
        }
        if (
            !props.data.questionList[i].question.isAnswered &&
            props.data.questionList[i].question.isVisited &&
            !props.data.questionList[i].question.isMarkedForReview
        ) {
            na = na + 1
        }
        if (props.data.questionList[i].question.isVisited) {
            v = v + 1
        }
        if (
            props.data.questionList[i].question.isMarkedForReview &&
            !props.data.questionList[i].question.isAnswered
        ) {
            r = r + 1
        }
        if (
            props.data.questionList[i].question.isMarkedForReview &&
            props.data.questionList[i].question.isAnswered
        ) {
            ra = ra + 1
        }
    }
    fa[0].value = s
    fa[1].value = na
    fa[2].value = r
    fa[3].value = props.data.questionList.length - v
    fa[4].value = ra
    let pv = 0
    let total = props.data.questionList.length
    let completion = ((s + ra) / total) * 100
    pv = completion.toFixed(0)

    function logEvents(eventName, description, item) {
        trackEvent(eventName, description, {
            [ANALYTICS_KEYS.SUCCESS]: true,
            [ANALYTICS_KEYS.QUESTION_ID]: item.question.questionid,
            [ANALYTICS_KEYS.QUESTION_TYPE]: item.question.questionType,
            [ANALYTICS_KEYS.OPTIONS_SELECTED]: item.question.answerbyUser,
        })
    }

    useEffect(() => {
        let d = [...props.testData.questionset]
        if (d) {
            for (let i = 0; i < d.length; i++) {
                if (d[i].subject === props.data.subject) {
                    d[i].questionList[0].question.isVisited = true
                    updateQues(d[i].questionList[0].question.questionid)
                    setTime(Date.now())
                }
            }
            props.onQuestionLoad(d)
        }
    }, [ques])

    useEffect(() => {
        window.addEventListener('click', handleClickOutside)

        return () => window.removeEventListener('click', handleClickOutside)
    }, [])

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            props.setToggle(false)
        }
    }

    const handleReview = (item) => {
        let activityType = 'Marked_For_Review'
        logEvents(
            EVENT_NAMES.TAP_REVIEW_WEB,
            'User taps on review option for any question',
            item,
        )

        let d = [...props.testData.questionset]
        for (let i = 0; i < d.length; i++) {
            if (d[i].subject === props.data.subject) {
                for (let j = 0; j < d[i].questionList.length; j++) {
                    if (
                        d[i].questionList[j].question.questionid ===
                        item.question.questionid
                    ) {
                        if (d[i].questionList[j].question.isMarkedForReview) {
                            d[i].questionList[j].question.isMarkedForReview = false
                            activityType = 'UnMarked_For_Review'
                        } else {
                            d[i].questionList[j].question.isMarkedForReview = true
                        }
                    }
                }
            }
        }
        props.onQuestionLoad(d).then(() => {
            calculateTimeSpent(
                item.question.questionid,
                d,
                false,
                true,
                activityType,
            )
        })
    }
    const handleReset = (item) => {
        logEvents(
            EVENT_NAMES.TAP_RESET_WEB,
            'User taps on reset option for any question',
            item,
        )
        let d = [...props.testData.questionset]
        for (let i = 0; i < d.length; i++) {
            if (d[i].subject === props.data.subject) {
                for (let j = 0; j < d[i].questionList.length; j++) {
                    if (
                        d[i].questionList[j].question.questionid ===
                        item.question.questionid
                    ) {
                        d[i].questionList[j].question.answerbyUser = []
                        d[i].questionList[j].question.isAnswered = false
                    }
                }
            }
        }
        props.onQuestionLoad(d).then(() => {
            calculateTimeSpent(
                item.question.questionid,
                d,
                false,
                true,
                'Reset_All_options',
            )
        })
    }

    const handleForwardPagination = (k, l, item, isSwitch = false, activityType) => {
        const debouncedSave = debounce(() => {
            let d = [...props.testData.questionset]
            calculateTimeSpent(item.question.questionid, d, isSwitch)
            if (k < l - 1) {
                if (!props.isPreview) {
                    logEvents(
                        EVENT_NAMES.TAP_NEXT_WEB,
                        'User taps on the next button on any question',
                        item,
                    )
                }

                for (let i = 0; i < d.length; i++) {
                    if (d[i].subject === props.data.subject) {
                        for (let j = 0; j < d[i].questionList.length; j++) {
                            if (
                                d[i].questionList[j].question.questionid ===
                                props.data.questionList[k + 1].question.questionid
                            ) {
                                d[i].questionList[j].question.isVisited = true
                                d[i].questionList[
                                    j
                                ].question.isCurrentlyOpened = true
                                // d[i].questionList[j].question.answerbyUser = [""]
                            } else {
                                d[i].questionList[
                                    j
                                ].question.isCurrentlyOpened = false
                            }
                        }
                    }
                }
                props.onQuestionLoad(d)
            }
            setActiveIndex(k)
            if (k == l - 1 && !isSwitch) {
                if (props.active + 1 <= props.sectionCount - 1) {
                    for (
                        let i = 0;
                        i < d[props.active + 1]['questionList'].length;
                        i++
                    ) {
                        if (i == 0) {
                            d[props.active + 1]['questionList'][i][
                                'question'
                            ].isCurrentlyOpened = true
                        } else {
                            d[props.active + 1]['questionList'][i][
                                'question'
                            ].isCurrentlyOpened = false
                        }
                    }
                }
                logEvents(
                    EVENT_NAMES.TAP_QUESTN_NAVGN_GRID_WEB,
                    'User taps on any question in the navigation grid ',
                    item,
                )
                let ai = props.active
                ai = ai + 1
                if (ai <= props.sectionCount - 1) {
                    props.setActive(ai)
                    props.setActiveSection(ai)
                }
            }
            if (!props.mock_test_submit) {
                props.onQuestionLoad(d).then(() => {
                    if (props.isPreview) return
                    Api.updateQuestion(
                        props,
                        d,
                        item.question.questionid,
                        activityType,
                    ).catch((error) => {
                        console.log(error)
                    })
                    props.setDisconnectTime(props.queryparam.disconnect_time * 60)
                })
            }
            props.setToggle(false)
        }, 0)
        debouncedSave()
    }

    const calculateTimeSpent = useCallback(
        (quesId, testData, isSwitch = false, isUpdate, actionType) => {
            let endTime = Date.now()
            let calculatedTime = Math.round((endTime - time) / 1000)
            setTime(endTime)
            let d = testData
            for (let i = 0; i < d.length; i++) {
                if (d[i].subject === props.data.subject) {
                    for (let j = 0; j < d[i].questionList.length; j++) {
                        if (
                            isSwitch &&
                            d[i].questionList[j].question.isCurrentlyOpened
                        ) {
                            quesId = d[i].questionList[j].question.questionid
                        }
                        if (d[i].questionList[j].question.questionid === quesId) {
                            d[i].questionList[j].question.timeSpent =
                                d[i].questionList[j].question.timeSpent +
                                calculatedTime
                        }
                    }
                }
            }
            props.onQuestionLoad(d)
            if (isUpdate) {
                Api.updateQuestion(props, d, quesId, actionType).catch((error) => {
                    console.log(error)
                })
                props.setDisconnectTime(props.queryparam.disconnect_time * 60)
            }
        },
        [props, time],
    )

    const handleBackWardPagination = (n, item, activityType) => {
        if (!props.isPreview) {
            logEvents(
                EVENT_NAMES.TAP_PREVIOUS_WEB,
                'User taps on the previous button on any question',
                item,
            )
        }

        if (n > 0) {
            let d = [...props.testData.questionset]
            calculateTimeSpent(item.question.questionid, d)
            for (let i = 0; i < d.length; i++) {
                if (d[i].subject === props.data.subject) {
                    for (let j = 0; j < d[i].questionList.length; j++) {
                        if (
                            d[i].questionList[j].question.questionid ===
                            props.data.questionList[n - 1].question.questionid
                        ) {
                            d[i].questionList[j].question.isCurrentlyOpened = true
                            d[i].questionList[j].question.isVisited = true
                            // d[i].questionList[j].question.answerbyUser = [""]
                        } else {
                            d[i].questionList[j].question.isCurrentlyOpened = false
                        }
                    }
                }
            }
            if (!props.mock_test_submit) {
                props.onQuestionLoad(d).then(() => {
                    if (props.isPreview) return
                    Api.updateQuestion(
                        props,
                        d,
                        item.question.questionid,
                        activityType,
                    ).catch((error) => {
                        console.log(error)
                    })
                    props.setDisconnectTime(props.queryparam.disconnect_time * 60)
                })
            }
        }
        if (n == 0) {
            let d = [...props.testData.questionset]
            let ai = props.active
            ai = ai - 1
            if (ai >= 0) {
                // d[ai].questionList.length.question.isCurrentlyOpened = true
                // d[ai].questionList.length-1
                for (let j = 0; j < d[ai].questionList.length; j++) {
                    if (j === d[ai].questionList.length - 1) {
                        d[ai].questionList[j].question.isCurrentlyOpened = true
                        d[ai].questionList[j].question.isVisited = true
                        // d[ai].questionList[j].question.answerbyUser = [""]
                    } else {
                        // d[ai].questionList[j].question.isVisited = true
                        d[ai].questionList[j].question.isCurrentlyOpened = false
                    }
                }
            }
            props.setActive(ai)
            props.setActiveSection(ai)
            props.onQuestionLoad(d).then(() => {
                if (props.isPreview) return
                Api.updateQuestion(
                    props,
                    d,
                    item.question.questionid,
                    activityType,
                ).catch((error) => {
                    console.log(error)
                })
                props.setDisconnectTime(props.queryparam.disconnect_time * 60)
            })
        }
    }

    const isInPhoneOrTablet = () => {
        if (window.matchMedia('(max-width: 768px)').matches) {
            //   console.log("width check",window.matchMedia("(max-width: 768px)").matches)
            return true
        }
        return false
    }
    //    const getAppendImgUrl = (text) => {
    //        const myRegex = /<img[^>]+src="?([^"\s]+)"?\s*\>/g;
    //        const url = myRegex.exec(text);
    //        let imageUrl = Api.getQuestionImageBaseUrl()
    //        let newText = text
    //        if(url && url.length > 0 && url[1].indexOf('s3') === -1){
    //               const appendBaseURL = imageUrl + '/' + url[1];
    //               console.log(appendBaseURL)
    //               newText = text.replace(url[1], appendBaseURL)
    //        }

    //        return newText
    // }
    const getAppendImgUrl = useCallback((text) => {
        const myRegex = /<img[^>]+src="?([^"\s]+)"?\s*\>/g
        let m,
            url = []
        while ((m = myRegex.exec(text))) {
            url.push(...m)
        }
        // const s3BaseURL = imageUrl
        let imageUrl = Api.getQuestionImageBaseUrl()
        let newText = text
        for (let i = 0; i < url.length; i += 2) {
            if (url[i + 1].indexOf('http') === -1) {
                const appendBaseURL = imageUrl + '/' + url[i + 1]
                newText = newText.replace(url[i + 1], appendBaseURL)
            }
        }
        return newText
    }, [])

    return props.data.questionList.map((item, i) => {
        return item.question.isCurrentlyOpened === true ? (
            <div
                className={
                    props.active === props.index
                        ? 'tab-content active'
                        : 'tab-content'
                }
                key={`question-${item.qid}`}
            >
                <section role="section" className="left-panel" id="ml">
                    <div className="question-number">
                        {item.qid}{' '}
                        {!props.isPreview ? (
                            <div className="reset-review">
                                {item.question.isAnswered &&
                                !props.mock_test_submit ? (
                                    <span
                                        className="que-reset"
                                        onClick={() => handleReset(item)}
                                    >
                                        <img src={reset} />
                                        <span>{'Reset'}</span>
                                    </span>
                                ) : (
                                    ''
                                )}
                                {!props.mock_test_submit ? (
                                    <span
                                        className="que-review"
                                        onClick={() => handleReview(item)}
                                    >
                                        <img
                                            src={
                                                item.question.isMarkedForReview
                                                    ? reviewed
                                                    : review
                                            }
                                        />
                                        <span>{'Review'}</span>
                                    </span>
                                ) : null}
                            </div>
                        ) : null}
                    </div>

                    <div role="note">
                        <Mathjax
                            html={getAppendImgUrl(item.question[i18n.language])}
                        />
                    </div>

                    <Answer
                        isPreview={props.isPreview}
                        getAppendImgUrl={getAppendImgUrl}
                        answerType={item.question.questionType}
                        subject={props.data.subject}
                        answerData={item}
                        calculateTimeSpent={calculateTimeSpent}
                        setDisconnectTime={props.setDisconnectTime}
                    />

                    <footer className="prev-next">
                        {props.index === 0 && i === 0 ? (
                            ''
                        ) : (
                            <Button
                                name={'Previous'}
                                style={
                                    // (props.islast &&
                                    // props.data.questionList.length === i + 1) ||
                                    props.mock_test_submit
                                        ? {
                                              textAlign: 'center',
                                              fontSize: '14px',
                                              fontWeight: '700',
                                              width: '90%',
                                              minHeight: '47px',
                                              padding: '12px',
                                              border: '1px solid #ffff',
                                              color: '#fff',
                                              background: '#00b0f5',
                                              marginRight: '2%',
                                          }
                                        : {
                                              textAlign: 'center',
                                              fontSize: '12px',
                                              border: '1px solid #414141',
                                              fontWeight: '700',
                                              marginRight: '2%',
                                              width: '90%',

                                              //    color:'red',
                                              //    background:'pink'
                                          }
                                }
                                classes={'prev'}
                                onClick={() =>
                                    handleBackWardPagination(i, item, 'Navigation')
                                }
                            />
                        )}

                        {props.islast && props.data.questionList.length === i + 1 ? (
                            !props.mock_test_submit ? (
                                <Link
                                    to="/submit"
                                    className="button next"
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '14px',
                                        fontWeight: '700',
                                        width: '90%',
                                        minHeight: '47px',
                                        padding: '12px',
                                        border: '1px solid #ffff',
                                        color: '#fff',
                                        background: '#00b0f5',
                                        marginLeft: '2%',
                                    }}
                                >
                                    {'Submit'}
                                </Link>
                            ) : (
                                ''
                            )
                        ) : (
                            <Button
                                name={'Next'}
                                style={
                                    (isInPhoneOrTablet &&
                                        props.index === 0 &&
                                        i === 0 &&
                                        item.question.isAnswered) ||
                                    props.mock_test_submit
                                        ? {
                                              textAlign: 'center',
                                              fontSize: '14px',
                                              fontWeight: '700',
                                              width: '90%',
                                              minHeight: '47px',
                                              padding: '12px',
                                              border: '1px solid #ffff',
                                              color: '#fff',
                                              background: '#00b0f5',
                                              marginLeft: '2%',
                                          }
                                        : {
                                              textAlign: 'center',
                                              fontSize: '12px',
                                              border: '1px solid #414141',
                                              fontWeight: '700',
                                              marginLeft: '2%',
                                              width: '90%',
                                          }
                                }
                                classes={`prev ${
                                    item.question.isAnswered ? 'next' : ''
                                }`}
                                onClick={() =>
                                    handleForwardPagination(
                                        i,
                                        props.data.questionList.length,
                                        item,
                                        false,
                                        'Navigation',
                                    )
                                }
                            />
                        )}
                    </footer>
                </section>
                <aside
                    className={
                        props.toggle?.toggle ? 'right-panel active' : 'right-panel'
                    }
                    ref={wrapperRef}
                >
                    <AnswerStatus
                        data={props.data}
                        mockTestSubmit={props.mock_test_submit}
                        statusData={fa}
                        qid={item.qid}
                        progressValue={pv}
                        isCurrentlyOpened={item.question.isCurrentlyOpened}
                        handleSwitchQuestion={handleForwardPagination}
                        queryparam={props.queryparam}
                    />
                </aside>
            </div>
        ) : (
            ''
        )
    })
}

export default memo(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(QuestionSection)),
)
